import { Tournament } from "@portal-frontend-ssr/blast-data-api";
import { formatTournamentDate } from "~/shared/components/ArticlePage/components/ArticlePageSidebar/components/shared/components/TournamentWidget/helpers/formatTournamentDate";

const TournamentHeader = ({ tournament }: { tournament: Tournament }) => {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex justify-between gap-2">
        <span className="max-w-60 truncate font-style-heading-h4">{tournament.name}</span>
        <div className="flex w-fit items-center justify-center whitespace-nowrap rounded-small bg-white px-2 text-background-100 font-style-label-l4">
          {formatTournamentDate({
            startDate: tournament.startDate,
            endDate: tournament.endDate ?? undefined,
            type: "long",
          })}
        </div>
      </div>
      <div className="flex gap-1 text-neutral font-style-label-l4">
        <span>{tournament.prizePool}</span>
        {tournament.numberOfTeams && (
          <>
            <span>|</span>
            <span>{tournament.numberOfTeams} teams</span>
          </>
        )}
        {tournament.location && (
          <>
            <span>|</span>
            <span>{tournament.location}</span>
          </>
        )}
      </div>
    </div>
  );
};

export { TournamentHeader };
